import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
  }

  .tag {
    display: flex;
    align-items: center;
    border: solid 1px;
    line-height: 1;
    white-space: nowrap;
    user-select: none;
    -webkit-user-select: none;
  }

  .tag__remove::part(base) {
    color: inherit;
    padding: 0;
  }

  /*
   * Variant modifiers
   */

  .tag--primary {
    background-color: var(--webmodule-color-primary-50);
    border-color: var(--webmodule-color-primary-200);
    color: var(--webmodule-color-primary-800);
  }

  .tag--primary:active > webmodule-icon-button {
    color: var(--webmodule-color-primary-500);
  }

  .tag--success {
    background-color: var(--webmodule-color-success-50);
    border-color: var(--webmodule-color-success-200);
    color: var(--webmodule-color-success-800);
  }

  .tag--success:active > webmodule-icon-button {
    color: var(--webmodule-color-success-600);
  }

  .tag--neutral {
    background-color: var(--webmodule-color-neutral-50);
    border-color: var(--webmodule-color-neutral-200);
    color: var(--webmodule-color-neutral-800);
  }

  .tag--neutral:active > webmodule-icon-button {
    color: var(--webmodule-color-neutral-600);
  }

  .tag--warning {
    background-color: var(--webmodule-color-warning-50);
    border-color: var(--webmodule-color-warning-200);
    color: var(--webmodule-color-warning-800);
  }

  .tag--warning:active > webmodule-icon-button {
    color: var(--webmodule-color-warning-600);
  }

  .tag--danger {
    background-color: var(--webmodule-color-danger-50);
    border-color: var(--webmodule-color-danger-200);
    color: var(--webmodule-color-danger-800);
  }

  .tag--danger:active > webmodule-icon-button {
    color: var(--webmodule-color-danger-600);
  }

  /*
   * Size modifiers
   */

  .tag--small {
    font-size: var(--webmodule-button-font-size-small);
    height: calc(var(--webmodule-control-height-small) * 0.8);
    line-height: calc(var(--webmodule-control-height-small) - var(--webmodule-control-border-width) * 2);
    border-radius: var(--webmodule-control-border-radius-small);
    padding: 0 var(--webmodule-spacing-x-small);
  }

  .tag--medium {
    font-size: var(--webmodule-button-font-size-medium);
    height: calc(var(--webmodule-control-height-medium) * 0.8);
    line-height: calc(var(--webmodule-control-height-medium) - var(--webmodule-control-border-width) * 2);
    border-radius: var(--webmodule-control-border-radius-medium);
    padding: 0 var(--webmodule-spacing-small);
  }

  .tag--large {
    font-size: var(--webmodule-button-font-size-large);
    height: calc(var(--webmodule-control-height-large) * 0.8);
    line-height: calc(var(--webmodule-control-height-large) - var(--webmodule-control-border-width) * 2);
    border-radius: var(--webmodule-control-border-radius-large);
    padding: 0 var(--webmodule-spacing-medium);
  }

  .tag__remove {
    margin-inline-start: var(--webmodule-spacing-x-small);
  }

  /*
   * Pill modifier
   */

  .tag--pill {
    border-radius: var(--webmodule-border-radius-pill);
  }
`;
